// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3nLJz","consentsList":"PatientConsents_consentsList__1iJyQ","consentsListEmpty":"PatientConsents_consentsListEmpty__1QAbE"};